import { RestApi } from '../../common/services';
import { store } from '../../common/store/store';
import { ServiceLead, ServiceLeadFormValues, ServicePartner } from '../types';

const buildingId = () => store.getState().security.ui.buildingId;

const previewQuery = (preview: string | null): string => (preview ? `?preview=${encodeURIComponent(preview)}` : '');

/**
 * Katalog pro přihlášeného uživatele – BE už filtruje podle role v budově (admin/member).
 * S tokenem náhledu vrátí i nezveřejněného partnera, kterému token patří.
 */
export const getServiceCatalog = async (preview: string | null = null): Promise<ServicePartner[]> =>
  RestApi.get<never, ServicePartner[]>(`/building/${buildingId()}/service${previewQuery(preview)}`);

/** Odeslání poptávky – multipart kvůli přílohám (attachments[i]); odpovědi na formFields jako JSON v `data`. */
export const createServiceLead = async (
  offerSlug: string,
  values: ServiceLeadFormValues,
  preview: string | null = null
): Promise<ServiceLead> => {
  const formData = new FormData();
  formData.append('contactName', values.contactName.trim());
  formData.append('contactEmail', values.contactEmail.trim());
  formData.append('contactPhone', values.contactPhone);
  if (values.message.trim()) formData.append('message', values.message.trim());
  formData.append('data', JSON.stringify(values.answers));
  formData.append('consent', values.consent ? '1' : '0');

  if (values.attachments) {
    for (let i = 0; i < values.attachments.length; i++) {
      formData.append(`attachments[${i}]`, values.attachments[i]);
    }
  }

  return RestApi.post<FormData, ServiceLead>(`/building/${buildingId()}/service/${offerSlug}/lead${previewQuery(preview)}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
